import { render, staticRenderFns } from "./ieltsmentor_collapse_hinh_thuc_hoan_thanh_hoc_phi.vue?vue&type=template&id=76c01266&scoped=true"
import script from "./ieltsmentor_collapse_hinh_thuc_hoan_thanh_hoc_phi.vue?vue&type=script&lang=js"
export * from "./ieltsmentor_collapse_hinh_thuc_hoan_thanh_hoc_phi.vue?vue&type=script&lang=js"
import style0 from "./ieltsmentor_collapse_hinh_thuc_hoan_thanh_hoc_phi.vue?vue&type=style&index=0&id=76c01266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c01266",
  null
  
)

export default component.exports